import PressReleases from 'src/pages/PressReleases'
import { combineFallbacks, usePressReleases } from 'src/state'

const ReleasesPage = props => <PressReleases {...props} />

export async function getStaticProps() {
  const fallback = await combineFallbacks(usePressReleases.getFallback({}))

  return {
    props: { fallback },
  }
}

export default ReleasesPage
